module.exports = __webpack_public_path__ + "img/36.7.Chla.31d1430a.png";